<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.bell-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Notifications ') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/settings">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="save">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="queue_connection">
                  {{ $t('Notification processing') }}
                </label>
                <div class="pt-1">
                  <select class="form-input bg-white" id="queue_connection" required v-model="notification.queue_connection">
                    <option :value="null" disabled>
                      {{ $t('Select an option') }}
                    </option>
                    <option value="sync">{{ $t('Send synchronously') }}</option>
                    <option value="database">{{ $t('Should be queued to database and process latter') }}</option>
                  </select>
                </div>
                <template v-if="notification.queue_connection === 'database'">
                  <div v-if="command_1 || command_2" class="form-description-text px-2 md:flex justify-between">
                    {{ $t('Use this command for configuring cron jobs') }}.
                    <small v-if="command_1" class="bg-gray-200 font-semibold px-1"> {{ command_1 }}</small>
                    <small class="font-semibold" v-if="command_1 && command_2"> {{ $t('OR') }}</small>
                    <small v-if="command_2" class="bg-gray-200 font-semibold px-1"> {{ command_2 }}</small>
                  </div>
                </template>
              </div>
              <div class="flex justify-between col-span-3">
                <label class="form-label w-full pt-7 pl-5" for="repair_mailable">{{ $t('Repair module') }}</label>
                <div class="w-full flex">
                  <div class="w-full">
                    <label class="form-label" for="repair_mailable">{{ $t('Email') }}</label>
                    <div class="pt-1">
                      <input-switch :disabled-label="$t('Disabled')" :enabled-label="$t('Enabled')" id="repair_mailable" v-model="notification.repair_mailable"></input-switch>
                    </div>
                  </div>
                  <div class="w-full">
                    <label class="form-label" for="repair_smsable">{{ $t('SMS') }}</label>
                    <div class="pt-1">
                      <input-switch :disabled-label="$t('Disabled')" :enabled-label="$t('Enabled')" id="repair_smsable" v-model="notification.repair_smsable"></input-switch>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex justify-between col-span-3">
                <label class="form-label w-full pt-4 pl-5" for="sale_mailable">{{ $t('Sale module') }}</label>
                <div class="w-full flex">
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch :disabled-label="$t('Disabled')" :enabled-label="$t('Enabled')" id="sale_mailable" v-model="notification.sale_mailable"></input-switch>
                    </div>
                  </div>
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch :disabled-label="$t('Disabled')" :enabled-label="$t('Enabled')" id="sale_smsable" v-model="notification.sale_smsable"></input-switch>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex justify-between col-span-3">
                <label class="form-label w-full pt-4 pl-5" for="refund_mailable">{{ $t('Sale return module') }}</label>
                <div class="w-full flex">
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch :disabled-label="$t('Disabled')" :enabled-label="$t('Enabled')" id="refund_mailable" v-model="notification.refund_mailable"></input-switch>
                    </div>
                  </div>
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch :disabled-label="$t('Disabled')" :enabled-label="$t('Enabled')" id="refund_smsable" v-model="notification.refund_smsable"></input-switch>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex justify-between col-span-3">
                <label class="form-label w-full pt-4 pl-5" for="custom_bill_mailable">{{ $t('Custom bills module') }}</label>
                <div class="w-full flex">
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch
                        :disabled-label="$t('Disabled')"
                        :enabled-label="$t('Enabled')"
                        id="custom_bill_mailable"
                        v-model="notification.custom_bill_mailable"
                      ></input-switch>
                    </div>
                  </div>
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch
                        :disabled-label="$t('Disabled')"
                        :enabled-label="$t('Enabled')"
                        id="custom_bill_smsable"
                        v-model="notification.custom_bill_smsable"
                      ></input-switch>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex justify-between col-span-3">
                <label class="form-label w-full pt-4 pl-5" for="custom_product_mailable">{{ $t('Custom product module') }}</label>
                <div class="w-full flex">
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch
                        :disabled-label="$t('Disabled')"
                        :enabled-label="$t('Enabled')"
                        id="custom_product_mailable"
                        v-model="notification.custom_product_mailable"
                      ></input-switch>
                    </div>
                  </div>
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch
                        :disabled-label="$t('Disabled')"
                        :enabled-label="$t('Enabled')"
                        id="custom_product_smsable"
                        v-model="notification.custom_product_smsable"
                      ></input-switch>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex justify-between col-span-3">
                <label class="form-label w-full pt-4 pl-5" for="custom_product_mailable">{{ $t('Cashbook register opening/closing') }}</label>
                <div class="w-full flex">
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch
                        :disabled-label="$t('Disabled')"
                        :enabled-label="$t('Enabled')"
                        id="register_oc_mailable"
                        v-model="notification.register_oc_mailable"
                      ></input-switch>
                    </div>
                  </div>
                  <div class="w-full">
                    <div class="pt-1">
                      <input-switch
                        :disabled-label="$t('Disabled')"
                        :enabled-label="$t('Enabled')"
                        id="register_oc_smsable"
                        v-model="notification.register_oc_smsable"
                      ></input-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-app rounded-md shadow-sm" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'notification',
  metaInfo() {
    return {
      title: this.$i18n.t('Notification configuration'),
    };
  },
  data() {
    return {
      loading: true,
      command_1: null,
      command_2: null,
      notification: {
        queue_connection: 'sync',
        repair_mailable: false,
        repair_smsable: false,
        sale_mailable: false,
        sale_smsable: false,
        refund_mailable: false,
        refund_smsable: false,
        custom_bill_mailable: false,
        custom_bill_smsable: false,
        custom_product_mailable: false,
        custom_product_smsable: false,
        register_oc_mailable: false,
        register_oc_smsable: false,
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      axios
        .get(route('settings.get.notification-config'))
        .then((response) => {
          this.notification = response.data.data;
          this.command_1 = response.data.command_1;
          this.command_2 = response.data.command_2;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push('/admin/settings');
        });
    },
    save() {
      this.loading = true;
      axios
        .post(route('settings.set.notification-config'), this.notification)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
